import React from 'react';

import { Modals } from '../pages/lazy';
import { useApp } from '../store/AppContext';
import Sidebar from './appLayout/Sidebar';
import FeedbackDialog from './FeedbackDialog';
import JiraEpicsModal from './JiraEpicsModal';
import MainContent from './MainContent';
import PhaseExtendConfirmation from './PhaseExtendConfirmation';
import Toasts from './Toasts';
import YearImportModal from './YearImportModal';

export default function AppLayout() {
  const { modal, setYearImportModal, yearImportModal } = useApp();
  return (
    <div className="app">
      <Sidebar />
      <div className="main">
        <MainContent />
      </div>
      {modal && (
        <React.Suspense fallback={null}>
          <Modals />
        </React.Suspense>
      )}
      <PhaseExtendConfirmation />
      <JiraEpicsModal />
      {/* ── Modale import année ── */}
      {yearImportModal && (
        <div
          className="modal-overlay"
          onClick={() => !yearImportModal.loading && setYearImportModal(null)}
        >
          <YearImportModal />
        </div>
      )}
      <FeedbackDialog />
      <Toasts />
    </div>
  );
}
